import moment from "moment";
import { getValue } from "./sessionManager";
import config from "../../src/config";

export const roundNumber = (value) => {
  const number = Number(value);
  if (Number.isInteger(number)) {
    return number;
  } else {
    return number.toFixed(0);
  }
};

export const dateFormat = (value, format) => {
  return moment(value).format(format);
};

export const isNavActive = (moduleName) => {
  const moduleRule = getValue(moduleName);
  const subModuleList = moduleRule.submodule_list;
  const activeSubmoduleList = subModuleList.filter((item, index) => item.isActive);
  if (activeSubmoduleList.length > 0) return true;
  return false;
};

// export const getSubDomain = () => {
//   const parts = window.location.hostname.split('.');
//   console.log('parts', parts.includes("finapp"),parts.includes('localhost'),window.location.host)
//   if (parts.includes("finapp") === false && parts.includes('localhost') === false) {
//     //return 'aifuture.in'
//     return  window.location.host
//   }
//   else if (parts.includes('localhost')) {
//     return parts.length > 1 && parts[0].toLowerCase() !== 'www' ? parts[0] : null;
//   }
//   else if (parts.length <= 2 || parts[0].toLowerCase() === 'www') {
//     return null;
//   } else {
//     return parts[0];
//   }
// }

export const hasSubdomain = () => {
  // const subdomain = getSubDomain();
  const subdomain = getValue("subdomain") || "";
  //console.log("utils",subdomain)
  return subdomain;
};

// export const dateSub = (value1, value2) => {

// }
export const calcRiskPortfolioTraitsData = (totalAlloc, riskTraitsYearlyData) => {
  return (totalAlloc * riskTraitsYearlyData) / 100;
};

export const formatMoney = (value) => {
  if (isNaN(value) || value === null || value === undefined) {
    return "₹ 0";
  }
  const roundedValue = Math.round(Number(value));
  return `₹ ${new Intl.NumberFormat("en-IN").format(roundedValue)}`;
};

export const formatMessage = (message) => {
  if (!message) return [];

  // Clean the message by removing any error indicators like "FAILED:"
  const cleaned = message.replace(/^FAILED:\s*/i, "").trim();

  // Split the cleaned message into words
  const words = cleaned.split(" ");

  // Calculate initial chunk size as 50% of the total word count (you can adjust this percentage)
  const initialChunkSize = Math.ceil(words.length / 2);

  const lines = [];
  let chunkSize = initialChunkSize;

  while (words.length > 0) {
    // Take 'chunkSize' words for the current line
    lines.push(words.splice(0, chunkSize).join(" "));

    // Decrease the chunk size with each line, but never go below 1
    chunkSize = Math.max(1, chunkSize - 1);
  }

  return lines;
};

export function getLoopbackReturnUrl(path) {
  return `${window.location.origin}${path}`;
}

export function getLoopbackReturnUrlRedirectToBackEnd(path) {
  return config.base_url_4;
}

export function getAppName() {
  const hostname = window.location.hostname;

  if (hostname.includes("localhost") || hostname.includes("finapp")) {
    return "FinApp";
  }

  const parts = hostname.split(".");
  if (parts.length >= 2) {
    return parts[parts.length - 2];
  }

  return hostname;
}

export function setFavicon(url) {
  if (!url) return;
  const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
  link.type = "image/png";
  link.rel = "icon";
  link.href = url;
  document.getElementsByTagName("head")[0].appendChild(link);
}

export function encodePayload(obj) {
  if (typeof obj !== "object" || obj === null) {
    throw new Error("Payload must be a non-null object");
  }
  return encodeURIComponent(JSON.stringify(obj));
}

export function isValidNumber(value) {
  return typeof value === "number" && !isNaN(value) && isFinite(value);
}

export function numberToIndianWords(input) {
  const number = Number(input); // Convert string or number to a number
  if (isNaN(number)) return "Invalid number";
  const words = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  function twoDigits(n) {
    if (n < 10) return words[n];
    if (n < 20) return teens[n - 10];
    return tens[Math.floor(n / 10)] + (n % 10 ? " " + words[n % 10] : "");
  }

  function convert(n) {
    if (n === 0) return "Zero";
    let result = "";
    if (Math.floor(n / 10000000)) {
      result += twoDigits(Math.floor(n / 10000000)) + " Crore ";
      n %= 10000000;
    }
    if (Math.floor(n / 100000)) {
      result += twoDigits(Math.floor(n / 100000)) + " Lakh ";
      n %= 100000;
    }
    if (Math.floor(n / 1000)) {
      result += twoDigits(Math.floor(n / 1000)) + " Thousand ";
      n %= 1000;
    }
    if (Math.floor(n / 100)) {
      result += words[Math.floor(n / 100)] + " Hundred ";
      n %= 100;
    }
    if (n > 0) {
      result += (result ? "and " : "") + twoDigits(n);
    }
    return result.trim();
  }

  return convert(number);
}
